module.exports = __webpack_public_path__ + "static/img/box-2.4b6cb61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/box-2.png
// module id = 4gbo
// module chunks = 1